import { useApplyReAssessment } from "@/api/console/re-assessments/useApplyReAssessment";
import DropdownButton from "@/components/DropdownButton";
import { STATUS } from "@/config/progress";
import toast from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

interface ActionButtonProps {
  id: number;
  status: number;
}

function ActionButton({ id, status }: ActionButtonProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { trigger } = useApplyReAssessment(String(id), {
    onSuccess: (data) => {
      const statues = [
        STATUS.ASSESSMENT_COMPLETED,
        STATUS.RE_ASSESSMENT,
        STATUS.RE_ASSESSMENT_GRADED_COMPLETED,
        STATUS.RE_ASSESSMENT_EVALUATION_COMPLETED,
      ];
      mutate(`/console/assessment_progresses?status=${statues.join(",")}`);
      toast.success(data.message);
    },
  });

  return (
    <DropdownButton
      width="200px"
      items={[
        {
          key: "apply-re-assessment",
          item: t("apply-re-assessment"),
          hide: status !== STATUS.ASSESSMENT_COMPLETED,
          onClick: () => {
            toast.loading(t("applying-re-assessment"));
            trigger();
          },
        },
        {
          key: "check-re-assessment",
          item: t("check-re-assessment"),
          hide: status !== STATUS.RE_ASSESSMENT,
          onClick: () => {
            navigate(`/console/re-assessments/${id}`);
          },
        },
        {
          key: "create-report",
          item:
            status === STATUS.RE_ASSESSMENT_GRADED_COMPLETED
              ? t("create-report")
              : t("edit-report"),
          hide: status < STATUS.RE_ASSESSMENT_GRADED_COMPLETED,
          onClick: () => {
            navigate(`/console/re-assessments/${id}/evaluate`);
          },
        },
        {
          key: "manage-report",
          item: t("manage-report"),
          hide: status < STATUS.RE_ASSESSMENT_EVALUATION_COMPLETED,
          onClick: () => {
            window.open(
              `/console/assessment-results/${id}?isFirstTime=false`,
              "_blank",
            );
          },
        },
      ]}
    />
  );
}

export default ActionButton;
